'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/inline-style-prefixer/lib/plugins/backgroundClip.js
// module id = 193
// module chunks = 0